import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpacemouse = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1248 13H6.79985C6.01534 13 5.53489 12.1342 5.87429 11.4269C6.71645 9.67182 6.88551 8.27665 6.93123 6.33681C6.94253 5.85767 7.28551 5.44746 7.75872 5.37147C10.8224 4.87952 13.3231 4.8733 16.2747 5.37009C16.7328 5.44719 17.0678 5.84011 17.0879 6.30418C17.1765 8.35277 17.3026 9.7639 18.0642 11.3769C18.4057 12.1004 17.9249 13 17.1248 13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.8631 15H5.09845C4.65316 15 4.25479 15.2933 4.15777 15.7279C3.94903 16.6629 3.94702 17.3738 4.15413 18.2821C4.25222 18.7122 4.6486 19 5.08978 19H18.8772C19.2918 19 19.671 18.7462 19.7895 18.3489C20.0708 17.4058 20.0714 16.6691 19.7841 15.6681C19.6678 15.2629 19.2847 15 18.8631 15Z",
			fill: "currentColor"
		})
	]
});
export default SvgSpacemouse;
